<template>
  <base-wrapper>
    <div class="space-y-6">
      <check-order-table v-model="selectedOrders" />

      <base-card>
        <base-input
          inset
          disabled
          label="Total Yang Dibayarkan"
          :value="totalPrice | toCurrency"
        />
      </base-card>

      <base-card class="grid grid-cols-2 gap-4">
        <base-input
          inset
          label="Nama Laporan"
          placeholder="ex: Laporan Penjualan"
          v-model="reportDetail.name"
        />
        <base-input
          inset
          label="Deskripsi Laporan"
          placeholder="ex: Laporan Penjualan"
          v-model="reportDetail.description"
        />
      </base-card>

      <create-payment-form
        v-if="pusatUuid"
        sync
        :office-id="pusatUuid"
        :with-validate-button="false"
        :with-summary="false"
        with-overpayment-balance
        :overpayment-balance="overpaymentBalance"
        :overpayment-balance-used="overpaymentBalanceUsed"
        v-model="paymentMethods"
        @input-overpayment-balance-used="
          (val) => (overpaymentBalanceUsed = val)
        "
      />

      <div class="flex justify-end">
        <base-button
          :disabled="totalPrice < 1 || paymentMethods.length < 1"
          @click="onSubmit"
          >Simpan Laporan</base-button
        >
      </div>
    </div>

    <base-confirm
      :visible="visibleSuccess"
      icon-type="badge"
      type="success"
      :with-cancel="false"
      message="Laporan berhasil disimpan"
      confirm-text="Kembali"
      @confirmed="$router.push({ name: 'laporan-penjualan-sc' })"
    />

    <loading v-if="loading" />
  </base-wrapper>
</template>
<script>
import CheckOrderTable from '@/components/order-bundles/check-order-table.vue';
import CreatePaymentForm from '@/components/payment/create-payment-form.vue';
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import dayjs from 'dayjs';
import { mapActions, mapGetters } from 'vuex';
import { requestMixin } from '../../../../mixins/request/request';

export default {
  mixins: [requestMixin],
  components: {
    CheckOrderTable,
    CreatePaymentForm,
    BaseConfirm,
  },
  data() {
    return {
      loadingSubmit: false,
      loadingPusatUuid: null,
      paymentMethods: [
        {
          paymentMethodId: null,
          paymentMethodTypeId: null,
          amount: null,
          officeBankId: null,
          receiptNumber: null,
        },
      ],
      reportDetail: {
        name: null,
        description: null,
      },
      selectedOrders: [],
      visibleSuccess: false,
      pusatUuid: null,
      overpaymentBalance: 0,
      overpaymentBalanceUsed: 0,
      loadingBalance: null,
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    loading() {
      return this.loadingSubmit || this.loadingPusatUuid || this.loadingBalance;
    },
    totalPrice() {
      return this.selectedOrders.reduce(
        (sum, order) => sum + order.reportPrice,
        0
      );
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadPusatUuid() {
      this.loadingPusatUuid = true;

      const [res, err] = await this.request(`/api/v1/offices`, {
        params: {
          'filter[office_category_id]': 1,
          'filter[code]': 'PUSAT',
          'fields[simple-offices]': 'office_id',
        },
      });

      if (!err) {
        this.pusatUuid = res.data[0].attributes.office_id;
      }

      this.loadingPusatUuid = false;
    },
    async loadOverpaymentBalance() {
      this.loadingBalance = true;

      const [res, err] = await this.request(
        `/api/v1/offices/${this.me.office_id}`,
        {
          params: {
            'fields[offices]': 'overpayment_balance',
          },
        }
      );

      if (!err) {
        this.overpaymentBalance = res.data.attributes.overpayment_balance;
      }

      this.loadingBalance = false;
    },
    async onSubmit() {
      if (this.overpaymentBalanceUsed && this.overpaymentBalanceUsed.replace(/\D/gi, '') > this.overpaymentBalance) {
        this.createAlert({
          status: 'error',
          data: 'Saldo yang digunakan melebihi saldo sisa',
        });

        return
      }

      this.loadingSubmit = true;

      const [res, err] = await this.request(`/api/v1/order-bundles`, {
        method: 'post',
        data: {
          data: {
            type: 'order-bundles',
            attributes: {
              name: this.reportDetail.name,
              description: this.reportDetail.description,
            },
            relationships: {
              office: {
                data: {
                  type: 'offices',
                  id: this.me.office_id,
                },
              },
              orders: {
                data: this.selectedOrders.map((order) => ({
                  type: 'orders',
                  id: order.id,
                })),
              },
            },
          },
        },
      });

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        const nonBalanceMethods = this.paymentMethods.map((paymentMethod) => {
          return this.request(`/api/v1/payment-bundles`, {
            method: 'post',
            data: {
              data: {
                type: 'payment-bundles',
                attributes: {
                  payment_amount: paymentMethod.amount
                    ? +paymentMethod.amount.replace(/\D/gi, '')
                    : null,
                },
                relationships: {
                  'order-bundle': {
                    data: {
                      type: 'order-bundles',
                      id: res.data.id,
                    },
                  },
                  ...(paymentMethod.officeBankId
                    ? {
                        'office-bank': {
                          data: {
                            type: 'office-banks',
                            id: paymentMethod.officeBankId,
                          },
                        },
                      }
                    : {}),
                },
              },
            },
          });
        });
        await Promise.all(
          [
            ...nonBalanceMethods,
            !this.overpaymentBalanceUsed
              ? null
              : this.request(`/api/v1/payment-bundles`, {
                  method: 'post',
                  data: {
                    data: {
                      type: 'payment-bundles',
                      attributes: {
                        payment_amount: +this.overpaymentBalanceUsed.replace(
                          /\D/gi,
                          ''
                        ),
                      },
                      relationships: {
                        'order-bundle': {
                          data: {
                            type: 'order-bundles',
                            id: res.data.id,
                          },
                        },
                      },
                    },
                  },
                }),
          ].filter((item) => !!item)
        );

        this.visibleSuccess = true;
      }

      this.loadingSubmit = false;
    },
  },
  created() {
    const defaultDetail = `Lap-${this.me.office_code}-${dayjs().format(
      'DD-MM-YYYY'
    )}`;

    this.reportDetail.name = defaultDetail;
    this.reportDetail.description = defaultDetail;

    this.loadPusatUuid();
    this.loadOverpaymentBalance();
  },
};
</script>
